import React from 'react';
import './AppIcon.css'; // Import your CSS file for styling
const AppIcon = ({ logo, name, description, comingsoon }) => {
    return (
        <div className="app-icon">
            <div className="image-container">
              <img
                className="logo"
                src={logo}
                alt={name}
              />
              {comingsoon && <div className="image-text">Coming Soon</div>}
            </div>
        <h3>{name}</h3>
        <p>{description}</p>
      </div>
    );
  };

export default AppIcon